/* RESPONSIBLE TEAM: team-ai-agent */

export function resolutionBotBillingFeature(app: any): string {
  if (app.hasAnswerBot) {
    return 'answer_workflows';
  } else {
    return 'ai_answers_billing_feature';
  }
}
